<template>
  <div style="margin-bottom: 6rem">
    <List>
      <ListItem><Button type="dashed" icon="ios-add" long @click="NewBuildHandleClick">新增</Button></ListItem>
      <ListItem v-for="item of list" :key="item.ClassificationID">
        <ListItemMeta
          :avatar="item.IconUrl"
          title="大类名称"
          :description="item.Classification"
        />
        <ListItemMeta title="单位" :description="item.unit" />
        <ListItemMeta title="辅助数量描述" :description="item.AQDescription" />
        <ListItemMeta title="库存数量" :description="item.InventoryQuantity" />
        <template slot="action">
          <li>
            <Button type="primary" shape="circle" icon="ios-create-outline" @click="EditHandleClick(item)">编辑</Button>
          </li>
          <li>
            <span></span>
            <Dropdown style="margin-left: 20px" @on-click="SelectHandleClick" @on-visible-change="VisibleChangeHandle(item)">
              <Button type="primary">
                更多
                <Icon type="ios-arrow-down"></Icon>
              </Button>
              <DropdownMenu slot="list">
                <DropdownItem name="上移" >上移</DropdownItem>
                <DropdownItem name="下移" >下移</DropdownItem>
                <DropdownItem name="删除" >删除</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </li>
        </template>
      </ListItem>
    </List>
    <Modal
        title="物料大类编辑"
        v-model="ModalShow"
        :loading="isloading"
        @on-ok="SubmitHandleClick('formCustom')"
        :closable="false">
        <Form :model="info" label-position="top" ref="formCustom" :rules="ruleCustom" >
           <FormItem prop="IconUrl">
               <Avatar :src="info.IconUrl" style="margin-left:2rem"/>
               <Upload :action="baseUrl + 'uploadProject'"
                       :max-size="1024"
                       :format="['jpg','jpeg','png','ico']"
                       :show-upload-list="false"
                       :on-success="handleSuccess"
                       :on-format-error="handleFormatError"
                       :headers="headers">
                  <Button icon="ios-cloud-upload-outline">上传图标</Button>
               </Upload>
           </FormItem>
           <FormItem label="名称ID">
               <Input v-model="info.ClassificationID" disabled></Input>
           </FormItem>
           <FormItem label="大类名称" prop="Classification">
               <Input v-model="info.Classification"></Input>
           </FormItem>
           <FormItem label="单位" prop="unit">
               <Select v-model="info.unit">
                <Option value="kg">kg</Option>
                <Option value="个">个</Option>
              </Select>
           </FormItem>
           <FormItem label="辅助数量描述" >
               <Input v-model="info.AQDescription" maxlength="20"></Input>
           </FormItem>
           <FormItem label="库存数量" >
               <Input type="number" v-model="info.InventoryQuantity"></Input>
           </FormItem>
        </Form>
    </Modal>
  </div>
</template>

<script>

import { MaterialCategory, ChangeMaterialCategory, MaterialCategoryMove } from '../../../api/Materiel'
import config from '../../../config/index'
export default {
  name: 'MaterialCategory',
  data () {
    const validateIconUrl = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请上传图标'))
      }
      callback()
    }
    const validateClassification = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请填写名称'))
      }
      callback()
    }
    const validateunit = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请选择单位'))
      }
      callback()
    }
    return {
      list: Array,
      baseUrl: '',
      ModalShow: false,
      isloading: true,
      info: {
        IconUrl: '',
        ClassificationID: '',
        Classification: '',
        unit: '',
        AQDescription: '',
        InventoryQuantity: ''
      },
      headers: {
        Authorization: 'Bearer ' + this.$store.state.token
      },
      State: 0,
      ruleCustom: {
        IconUrl: [{ validator: validateIconUrl, trigger: 'blur' }],
        Classification: [{ validator: validateClassification, trigger: 'blur' }],
        unit: [{ validator: validateunit, trigger: 'blur' }]
      }
    }
  },
  mounted: function () {
    this.baseUrl = config.baseUrl.pro
    this.GetMaterialCategoryData()
  },
  methods: {
    //   获取大类数据
    GetMaterialCategoryData () {
      MaterialCategory().then((res) => {
        if (res.IsSuccess) {
          this.list = res.Data
        } else {
          this.$Message.error(res.Message)
        }
      })
    },
    // 点击编辑按钮事件
    EditHandleClick (item) {
      this.info = item
      this.isloading = true
      this.ModalShow = true
      this.State = 1
    },

    // 上传图片成功
    handleSuccess (res, file) {
      if (res.IsSuccess) {
        this.info.IconUrl = res.Data.url
        this.$Message['success']({
          background: true,
          content: '上传成功'
        })
      } else {
        this.$Message.error(res.Message)
      }
    },
    // 图片上传失败回调
    handleFormatError (file) {
      this.$Notice.warning({
        title: 'The file format is incorrect',
        desc: 'File format of ' + file.name + ' is incorrect, please select jpg or png.'
      })
    },
    // 点击确定按钮回调
    SubmitHandleClick (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.isloading = false
          this.ModalShow = false
          // this.$Modal.remove()
          this.OKHandleClick()
        } else {
          this.isloading = true
          setTimeout(() => {
            this.isloading = false
          }, 2000)
          this.$Message.error('Fail!')
        }
      })
    },
    OKHandleClick () {
      ChangeMaterialCategory({
        IconUrl: this.info.IconUrl,
        ClassificationID: this.info.ClassificationID,
        Classification: this.info.Classification,
        unit: this.info.unit,
        AQDescription: this.info.AQDescription,
        InventoryQuantity: this.info.InventoryQuantity,
        operation: this.State
      }).then((res) => {
        if (res.IsSuccess) {
          this.$Message['success']({
            background: true,
            content: '提交成功'
          })
          this.GetMaterialCategoryData()
        } else {
          this.$Message.error(res.Message)
        }
      })
    },

    // 下拉选择时触发
    SelectHandleClick (name) {
      if (name === '删除') {
        this.State = 2
        this.$Modal.confirm({
          title: '删除属性',
          content: '<p>确定删除 "' + this.info.Classification + '"这个分类？</p>',
          onOk: () => {
            this.OKHandleClick()
          }
        })
      } else if (name === '上移') {
        MaterialCategoryMove(this.info.ClassificationID, 1).then((res) => {
          if (res.IsSuccess) {
            this.$Message['success']({
              background: true,
              content: '操作成功'
            })
            this.GetMaterialCategoryData()
          } else {
            this.$Message.error(res.Message)
          }
        })
      } else if (name === '下移') {
        MaterialCategoryMove(this.info.ClassificationID, 0).then((res) => {
          if (res.IsSuccess) {
            this.$Message['success']({
              background: true,
              content: '操作成功'
            })
            this.GetMaterialCategoryData()
          } else {
            this.$Message.error(res.Message)
          }
        })
      }
    },
    // 下拉菜单出现时事件
    VisibleChangeHandle (item) {
      this.info = item
    },
    // 点击新增触发事件
    NewBuildHandleClick () {
      this.info = {
        IconUrl: '',
        ClassificationID: '',
        Classification: '',
        unit: '',
        AQDescription: '',
        InventoryQuantity: ''
      }
      this.isloading = true
      this.ModalShow = true
      this.State = 0
    }
  }
}
</script>
